import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import GeneralData from "../../../data/GeneralData.js";
import "../SliderHome/style.css";
import clsx from "clsx";

export const SliderHome = () => {
  const history = useHistory();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth] = useState(window.innerWidth);

  const goToDirection = (event, location) => {
    event.preventDefault();
    history.push(location);
  };

  const bannerList = [
    {
      src:
        windowWidth > 520
          ? `${GeneralData.host}images/slider-1/banner-1.png`
          : `${GeneralData.host}images/slider-1/banner-small-1.png`,
      alt: "paga-tu-cuota",
      onClick: (event) => goToDirection(event, "/paga-tu-cuota"),
    },
    {
      src:
        windowWidth > 520
          ? `${GeneralData.host}images/slider-1/banner-2.png`
          : `${GeneralData.host}images/slider-1/banner-small-2.png`,
      alt: "financiamiento",
      onClick: (event) => goToDirection(event, "/financiamiento"),
    },
    {
      src:
        windowWidth > 520
          ? `${GeneralData.host}images/slider-1/banner-3.png`
          : `${GeneralData.host}images/slider-1/banner-small-3.png`,
      alt: "paga-tu-cuota",
      onClick: (event) => goToDirection(event, "/paga-tu-cuota"),
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % bannerList.length);
  };


  useEffect(() => {
    const interval = setInterval(nextSlide, 8000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSlider = useCallback(
    (direction) => {
      const newIndex =
        direction === "left"
          ? (currentIndex - 1 + bannerList.length) % bannerList.length
          : (currentIndex + 1) % bannerList.length;

      setCurrentIndex(newIndex);
    },
    [currentIndex, bannerList.length]
  );

  return (
    <section className="carousel" aria-label="Gallery">
      <ol className="carousel__viewport">
        {bannerList.map((banner, index) => (
          <li
            key={index}
            className={clsx(
              "carousel__slide",
              index === currentIndex && "active"
            )}
          >
            <div className="carousel__snapper">
              <a href="/">
                <img
                  className={clsx(
                    "c-slider-1__img-movil",
                    index === currentIndex && "active"
                  )}
                  src={banner.src}
                  alt={banner.alt}
                  onClick={banner.onClick}
                />
              </a>
            </div>
          </li>
        ))}
        <FontAwesomeIcon
          className="Iconleft"
          icon={faAngleLeft}
          onClick={() => handleSlider("left")}
        />
        <FontAwesomeIcon
          className="Iconright"
          icon={faAngleRight}
          onClick={() => handleSlider("right")}
        />
      </ol>
    </section>
  );
};
